import Vue from 'vue'
import Router from 'vue-router'
const Index = () => import('../componets/index.vue')

const GiftList = () => import('../componets/giftlist.vue')

const Rules = () => import('../componets/rules.vue')

const NewEmployeeBenefits = () => import('../componets/inviteEntrance.vue')
const OldInvite = () => import('../componets/NewEmployeeBenefits.vue')
const NewInvite = () => import('../componets/invite.vue')
const CompanyInvite = () => import('../pages/companyInvite.vue')
const Recognition = () => import('../pages/recognition.vue')
Vue.use(Router)

export default new Router({
    'mode': 'history',
    'base': '/mgm_invite/',
    'routes': [
        {
            'path': '/',
            'name': 'index',
            'component': Index
        },
        {
            'path': '/giftlist',
            'name': 'giftlist',
            'component': GiftList
        },
        {
            'path': '/rules',
            'name': 'rules',
            'component': Rules
        },
        {
            'path': '/future',
            'name': 'future',
            'component': NewEmployeeBenefits
        },
        {
            'path': '/oldInvite',
            'name': 'OldInvite',
            'component': OldInvite
        },
        {
            'path': '/newInvite',
            'name': 'NewInvite',
            'component': NewInvite
        },
        {
            'path': '/xiaoweiAuth',
            'name': 'xiaoweiAuth',
            'component': CompanyInvite
        },
        {
            'path': '/shareBottom',
            'name': 'shareBottom',
            'component': import('../componets/shareBottom.vue')
        },
        {
            'path': '/recognition',
            'name': 'recognition',
            'component': Recognition
        }
    ]
})
